import {mergeConversationsAsyncAction} from '../../../services/tasks/mergeConversationsTask';
import {ThunkAsyncAction} from '../../appThunk';
import {getOriginalConversations} from '../../data/dataSelectors';
import {navigateToLinkAction} from '../../stateless/navigationActions';

/** Merge conversations and navigate the user to the remaining conversation. */
export function mergeConversationsAndNavigateAsyncAction(
  conversationIds: ReadonlyArray<number>,
): ThunkAsyncAction {
  return async (dispatch, getState) => {
    const electedConversationId = await dispatch(mergeConversationsAsyncAction(conversationIds));
    const electedConversation = getOriginalConversations(getState())[electedConversationId];

    if (!electedConversation) {
      throw new Error('Could not find elected conversation after join.');
    }

    navigateToLinkAction(electedConversation.link);
  };
}
